<!-- Request type -->
<div class="flex-basis requests-data request-type">
    <div class="control-label">
        <span *ngIf="request.type != 'CopyrightRecord' && request.type != 'Bolk'">
            <i class="fa fa-bolt" aria-hidden="true"></i> {{'general.digitization' | translate}}
        </span>
        <span *ngIf="request.type == 'CopyrightRecord'">
            <i class="fa fa-copyright" aria-hidden="true"></i> {{'general.copyright' | translate}}
        </span>
        <span *ngIf="request.type == 'Bolk'">
            <i class="fa fa-bolt" aria-hidden="true"></i> {{'general.bolk' | translate}}
        </span>
    </div>
</div>
<!-- Request status -->
<div class="flex-basis requests-data request-status">
    <div *ngIf="request.status">
        <span *ngIf="!request.externalStatus" [ngClass]="{'label-ReadyForProcessing' : request.status=='ACTIVE', 'label-Declined' : (request.status=='FAILED' || request.status=='REJECTED' || request.status=='Rejected'), 'label-success' : request.status=='COMPLETED'}">
            {{'request.dialog.status.'+request.status | translate}}
        </span>
        <span *ngIf="request.externalStatus" [ngClass]="{'label-ReadyForProcessing' : (request.status=='ACTIVE' || request.status=='WAITINGFORAPPROVAL'), 'label-Declined' : (request.status=='FAILED' || request.status=='REJECTED' || request.status=='Rejected'), 'label-success' : request.status=='COMPLETED'}">
            {{'CitationCopyRights.' + request.status | translate}}
            ({{'request.dialog.status.'+request.externalStatus | translate}} {{'citation.reqeusts.statusPrefix.' + request.type | translate}})
        </span>
    </div>
</div>
<div class="flex-basis requests-data request-content">
    <!-- Request Chapter -->
    <div class="request-content-data" *ngIf="request.requiredChapters">
        <h4 class="title">{{'request.dialog.chapter' | translate}}:</h4>
        <span class="form-data">{{request.requiredChapters}}</span>
    </div>
    <!-- Request pages -->
    <div class="request-content-data">
        <div *ngIf="request.scanFromPage || request.scanToPage">
            <div class="page-range-group">
                <h4 class="title">
                    {{'request.dialog.pages' | translate}}:
                </h4>
                <span *ngIf="request.scanFromPage" class="request-content-parameter">
                    <span class="control-label">{{'request.dialog.pageFrom' | translate}}:</span>
                    <span class="form-data">{{request.scanFromPage}}</span>
                </span>
                <span *ngIf="request.scanToPage" class="request-content-parameter">
                    <span class="control-label">{{'request.dialog.pageTo' | translate}}:</span>
                    <span class="form-data">{{request.scanToPage}}</span>
                </span>
            </div>
            <div class="page-range-group">
                <span *ngIf="request.scanFromPage2" class="request-content-parameter">
                    <span class="control-label">{{'request.dialog.pageFrom' | translate}}:</span>
                    <span class="form-data">{{request.scanFromPage2}}</span>
                </span>
                <span *ngIf="request.scanToPage2" class="request-content-parameter">
                    <span class="control-label">{{'request.dialog.pageTo' | translate}}:</span>
                    <span class="form-data">{{request.scanToPage2}}</span>
                </span>
            </div>
        </div>
    </div>
</div>
<!-- Request message -->
<div class="flex-basis requests-data request-message">
    <span *ngIf="request.message">
        <span class="form-data ContentSummary">{{request.message}}</span>
    </span>
</div>
<div class="flex-basis requests-data request-notes">
    <!-- Request note 1 -->
    <div class="request-content-data" *ngIf="request.note1">
        <div class="request-content-parameter note-1">
            <span class="note-toggle-btn">
                <button type="button" class="btn btn-link" (click)="openNote1=!openNote1" id="open-note-1-btn">
                    <i [ngClass]="{'fa-plus' : !openNote1, 'fa-minus' : openNote1}" class="fa" aria-hidden="true"></i>
                    <span class="control-label">
                        {{'request.dialog.note1' | translate}}
                    </span>
                </button>
            </span>
            <div class="form-data" *ngIf="openNote1">
                <span class="close-note-btn">
                    <button type="button" class="btn btn-link" id="closeNote1" (click)="openNote1=!openNote1">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </span>
                <span class="ContentSummary">
                    {{'request.dialog.note1' | translate}}:
                </span>
                <p>{{request.note1}}</p>
            </div>
        </div>
    </div>
    <!-- Request note 2 -->
    <div class="request-content-data" *ngIf="request.note2">
        <div class="request-content-parameter note-2">
            <span class="note-toggle-btn">
                <button type="button" class="btn btn-link" (click)="openNote2=!openNote2" id="open-note-2-btn">
                    <i [ngClass]="{'fa-plus' : !openNote2, 'fa-minus' : openNote2}" class="fa" aria-hidden="true"></i>
                    <span class="control-label">{{'request.dialog.note2' | translate}}</span>
                </button>
            </span>
            <div class="form-data" *ngIf="openNote2">
                <span class="close-note-btn">
                    <button type="button" class="btn btn-link" id="closeNote2" (click)="openNote2=!openNote2">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </span>
                <span class="ContentSummary">
                    {{'request.dialog.note2' | translate}}:
                </span>
                <p>{{request.note2}}</p>
            </div>
        </div>
    </div>
    <!-- Request note 3 -->
    <div class="request-content-data" *ngIf="request.note3">
        <div class="request-content-parameter note-3">
            <span class="note-toggle-btn">
                <button type="button" class="btn btn-link" (click)="openNote3=!openNote3" id="open-note-3-btn">
                    <i [ngClass]="{'fa-plus' : !openNote3, 'fa-minus' : openNote3}" class="fa" aria-hidden="true"></i>
                    <span class="control-label"> {{'request.dialog.note3' | translate}} </span>
                </button>
            </span>
            <div class="form-data" *ngIf="openNote3">
                <span class="close-note-btn">
                    <button type="button" class="btn btn-link" id="closeNote3" (click)="openNote3=!openNote3">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </span>
                <span class="ContentSummary">{{'request.dialog.note3' | translate}}:</span>
                <p>{{request.note3}}</p>
            </div>
        </div>
    </div>
</div>
<div class="flex-basis requests-data request-img" *ngIf="request.imageIncluded">
    <i class="fa fa-image" aria-hidden="true" uib-tooltip="{{'request.dialog.imageIncluded' | translate}}" tooltip-placement="top" aria-label="{{'request.dialog.imageIncluded' | translate}}"></i> {{'request.dialog.imageIncluded' | translate}}
</div>
<!-- Request cancel -->
<div class="flex-basis flex-left requests-data request-cancel" *ngIf="request.canDelete">
    <button type="button" class="btn btn-clear btn-delete pull-right" id="cancelRequest" uib-tooltip="{{'general.cancel' | translate}} {{'general.request' | translate}}" tooltip-placement="left" aria-label="{{'general.cancel' | translate}} {{'general.request' | translate}}" (click)="deleteRequest()" aria-label="{{'general.cancel' | translate}} {{'general.request' | translate}}">
        <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
</div>
<ng-content></ng-content>